import { useState, useCallback } from "react";
import { useHistory } from "react-router-dom";

const EMPSearchFieldRouting = () => {
  const history = useHistory();
  const [searchQuery, setSearchQuery] = useState("");

  const routeChange = useCallback(
    (e) => {
      if (e) e.preventDefault();
      if (searchQuery !== "") {
        history.push(`/search/${encodeURIComponent(searchQuery.trim())}`);
      }
    },
    [searchQuery, history]
  );

  const updateSearchQuery = useCallback((value) => {
    setSearchQuery(value);
  }, []);

  return { searchQuery, routeChange, updateSearchQuery };
};

export default EMPSearchFieldRouting;
